const map = {
	"./100x100.png": 2987,
	"./120x80image.png": 4307,
	"./150x100image.png": 1393,
	"./150x150image.png": 1728,
	"./1Offers64.png": 7625,
	"./50x50image.png": 7094,
	"./BayFay Cash.png": 5942,
	"./Card.png": 2473,
	"./Cash.png": 4810,
	"./Enquiry-active.png": 629,
	"./Enquiry.png": 9812,
	"./Faq.png": 3459,
	"./Help-active.png": 2719,
	"./Help.png": 4322,
	"./Net Banking.png": 1532,
	"./Offer-active.png": 2834,
	"./Offer.png": 273,
	"./Preferred.png": 9404,
	"./Profile&setting.png": 1110,
	"./Promo Code.png": 6175,
	"./Shopping-active.png": 6540,
	"./Shopping.png": 7607,
	"./UPI.png": 5239,
	"./axis-bank.png": 7797,
	"./bayfay-logo.png": 1247,
	"./cost-black.png": 6474,
	"./cost-blue.png": 2743,
	"./credit-card-icon-2.png": 5642,
	"./credit-card-icon.png": 8055,
	"./delivery-home.png": 5791,
	"./delivery-location.png": 9555,
	"./delivery-shop.png": 5842,
	"./download_from_app_store.png": 7982,
	"./download_from_play_store.png": 6425,
	"./facebook.png": 2799,
	"./google-pay.png": 4387,
	"./horn.png": 4904,
	"./instagram.png": 7543,
	"./kotac-bank.png": 4106,
	"./linkedin.png": 5405,
	"./logo-1024.png": 1296,
	"./logo-final-512x512.png": 1798,
	"./maestro.png": 6396,
	"./map-icon.png": 4535,
	"./master-card.png": 7714,
	"./other-delivery-pin.png": 5574,
	"./payments.png": 6601,
	"./pockets.png": 162,
	"./product-search-location.png": 309,
	"./promocode.png": 4993,
	"./sbi-bank.png": 1236,
	"./scratch-image.png": 6301,
	"./scratch_rewardBlue@3x.png": 4374,
	"./scratch_rewardGold@3x.png": 2944,
	"./shopping-cart.png": 484,
	"./support.png": 870,
	"./trackingbike.png": 9703,
	"./twitter.png": 2662,
	"./upipay.png": 5229,
	"./verified.png": 1671,
	"./visa.png": 2244,
	"./warning.png": 1823,
	"./youtube.png": 2616
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4504;